<div class="content mat-typography">
  <guide-country></guide-country>
</div>
<mat-dialog-actions class="app-buttons">
  <button mat-flat-button color="primary" class="button" mat-dialog-close
          i18n="Restrict country: Button [VERIFIED]"
          type="button" data-e2e="restrict-country">OK, keep me posted!</button>
</mat-dialog-actions>
